import React, { Component } from "react";
import { Wrapper, Card } from "app/NativeComponents/common";

import { PillButton } from "app/NativeComponents/snippets";
class Buttons extends Component {
  render() {
    return (
      <Wrapper
        style={{
          alignItems: this.props.buttonRight ? "flex-start" : "center",
          justifyContent: "center"
        }}
      >
        <PillButton
          formButton
          disabled={this.props.loading ? true : false}
          primary
        >
          {this.props.buttonText ? this.props.buttonText : "Complete"}
        </PillButton>
      </Wrapper>
    );
  }
}

export default Buttons;
